import {memo, useContext, useState} from "react";
import {Pagination, Table, Tooltip} from "antd";
import {
	renderDate,
} from "~/utils";
import {
	Image,
	StatusLabel,
	PopperUserInfo
} from "~/components";
import {AppContext} from "~/context/AppProvider";
import {ServiceToDoAction} from "../index";
import {useCan} from "../../../../hooks";
import {Button, Icon} from "../../../../components";

function ServiceToDoTable({items = [], pagination, onPaginationChange, openModal, handleStatus, handleFinished, setItemEdit}) {

	const {tableHeight} = useContext(AppContext);

	const can = {
		status: useCan('serviceToDoStatus'),
		finished: useCan('serviceToDoFinished'),
	}

	const [loadingStatus, setLoadingStatus] = useState(false);
	const [loadingStatusCancel, setLoadingStatusCancel] = useState(false);
	const [loadingFinishedCancel, setLoadingFinishedCancel] = useState(false);

	const buttonHandlers = {
		status: async (item, status) => {
			if(status === 'cancel') {
				setLoadingStatusCancel(true);
			}
			else {
				setLoadingStatus(true);
			}
			await handleStatus(item, status);
			if(status === 'cancel') {
				setLoadingStatusCancel(false);
			}
			else {
				setLoadingStatus(false);
			}
		},
		finished: async (item, status) => {
			if(status === 'cancel') {
				setLoadingFinishedCancel(true);
				await handleFinished(item, status);
				setLoadingFinishedCancel(false);
			}
			else {
				setItemEdit(item)
				openModal('finished');
			}
		},
		info: (item) => {
			setItemEdit(item);
			openModal('info');
		},
	};

	let columns = [
		{title: 'Dịch vụ', dataIndex: 'service', key: "service", width: '150px',render: (_, item) => (
			<>
				<p className="gap-1 d-flex mb-1">
					<StatusLabel small type={item.serviceType.badge}>{item.serviceType.label}</StatusLabel>
					<b>{(item?.service?.domain ? item.service.domain : item.domain)}</b>
				</p>
				{item.user?.id && <p>{`${item.user?.firstname} ${item.user?.lastname}`}</p>}
				{item.userShare?.id && <p>{`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
				<p className={'text-xs'} style={{color:'#ccc'}}>{renderDate(item?.time)}</p>
			</>
		)},
		{title: 'Hành động', dataIndex: 'action', key: "action", width: '140px', render: (_, item) => (
			<>
				<StatusLabel small type={item?.type.badge}>{item?.type.label}</StatusLabel>
				<p className={'mt-1'}>{item.service?.hostIp}</p>
			</>
		)},
		{title: 'Người tạo', dataIndex: 'user', key: "user", width: '240px', render: (_, item) => (
			item.userAdd?.id && <PopperUserInfo user={item.userAdd}>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item.userAdd?.avatar} /></div>
					<div>
						<p>{item.userAdd?.firstname} {item.userAdd?.lastname}</p>
						<p><StatusLabel small type={item.userAdd.role?.badge}>{item.userAdd.role?.label}</StatusLabel></p>
					</div>
				</div>
			</PopperUserInfo>
		)},
		{title: 'Người làm', dataIndex: 'userAction', key: "userAction", width: '210px', render: (_, item) => (
			item.userAction?.id && <PopperUserInfo user={item.userAction}>
				<div className="d-flex gap align-items">
					<div className="avatar"><Image src={item.userAction?.avatar} /></div>
					<div>
						<p>{item.userAction?.firstname} {item.userAction?.lastname}</p>
						<p><StatusLabel small type={item.userAction.role?.badge}>{item.userAction.role?.label}</StatusLabel></p>
					</div>
				</div>
			</PopperUserInfo>
		)},
		{title: 'Lý do', dataIndex: 'note', key: "note", width: '300px'},
		{title: 'Duyệt', dataIndex: 'status', key: "status", width: '200px', render: (_, item) => (
			<>
				<StatusLabel small type={item?.status.badge}>{item?.status.label}</StatusLabel>&nbsp;&nbsp;
				{
					can.status && <>
						{
							item.status.key !== 'confirm' && <Tooltip title="Duyệt">
								<Button loading={loadingStatus} background blue noneBorder small leftIcon={Icon.success} onClick={() => buttonHandlers.status(item, 'confirm')} />
							</Tooltip>
						}
						{
							item.status.key !== 'cancel' && <Tooltip title="Hủy">
								<Button loading={loadingStatusCancel} background red noneBorder small leftIcon={Icon.close} onClick={() => buttonHandlers.status(item, 'cancel')} />
							</Tooltip>
						}
					</>
				}
			</>

		)},
		{title: 'Kỹ thuật', dataIndex: 'finished', key: "finished", width: '200px', render: (_, item) => (
			<>
				<StatusLabel small type={item?.finished.badge}>{item?.finished.label}</StatusLabel>&nbsp;&nbsp;
				{
					(can.finished || can.status) && <>
						{
							item.finished?.key !== 'success' && <Tooltip title="Hoàn thành">
								<Button background blue noneBorder small leftIcon={Icon.success} onClick={() => buttonHandlers.finished(item, 'success')} />
							</Tooltip>
						}
						{
							item.finished?.key !== 'cancel' && <Tooltip title="Hủy">
								<Button loading={loadingFinishedCancel} background red noneBorder small leftIcon={Icon.close} onClick={() => buttonHandlers.finished(item, 'cancel')} />
							</Tooltip>
						}
					</>
				}
			</>
		)},
		{title: '#', dataIndex: 'action', key: "action", width: '80px', render: (_, item) => (
			<Tooltip title="Thông tin"><Button background blue small leftIcon={Icon.info} onClick={() => buttonHandlers.info(item)}></Button></Tooltip>
		)},
	];

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} rowKey="id" dataSource={items} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default memo(ServiceToDoTable);